import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import moment from "moment";
import NuDate from "../../Components/Utils/NuDate";
import logout from "../../Components/Utils/Logout";
import ModalContainer from "../../Components/Others/ModalContainer";
import BellIcon from "../../Components/Icons/BellIcon";
import DecryptData from "../../Components/Utils/Decrypt";
import LanguageSelector from "../../Components/Others/LanguageSelector";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Dashboard from "../../Components/Icons/Dasboard";
import { useCurrency } from "../../Context/CurrencyContext";
import socketAxiosInstance from "../../Services/socketAxiosCommon";
import {
  GetAccess,
  GetDashboardRole,
  GetMultipleAccess,
  GetRole,
  GetUseRole,
} from "../../Components/Utils/roles";
import { useToast } from "../../Components/Others/ToastServices";
import Chat from "../../Components/Icons/Chat";
import { useSocket } from "../../Context/SocketContext";
import { MenuOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import Members from "../../Components/Icons/Member";
import DashboardSide from "../../Components/Icons/DasboardSide";
import Bidding from "../../Components/Icons/Bidding";
import Project from "../../Components/Icons/Project";
import Notes from "../../Components/Icons/Notes";
import Procurement from "../../Components/Icons/Procurement";
import Sales from "../../Components/Icons/Sales";
import Store from "../../Components/Icons/Store";
import Contacts from "../../Components/Icons/Contacts";
import Report from "../../Components/Icons/Report";
import Settings from "../../Components/Icons/Settings";
import Costing from "../../Components/Icons/Budget";
import PlanTask from "../../Components/Icons/Planning";
import Task from "../../Components/Icons/Task";
import Progress from "../../Components/Icons/progress";
import Timesheet from "../../Components/Icons/TimeSheet";
import CompanyInfoIcon from "../../Components/Icons/Company";
import Products from "../../Components/Icons/Products";
import Shipping from "../../Components/Icons/Shipping";
import Role from "../../Components/Icons/Role";
import Staff from "../../Components/Icons/Staff";
import UserRole from "../../Components/Icons/UserRole";
import Reference from "../../Components/Icons/Reference";
import CurrencyIcon from "../../Components/Icons/Currency";
import PermissionIcon from "../../Components/Icons/Status";
import Email from "../../Components/Icons/Email";
import Template from "../../Components/Icons/Template";
import PDFTemplateIcon from "../../Components/Icons/PdfTemplate";
import Signature from "../../Components/Icons/Signatutre";
import { ArrowLeft, BadgeCheck, BellDot,ToggleLeft, BookOpenCheck, Building2, ClipboardCheck, Contact, FileSliders, FireExtinguisher, Hammer, LayoutDashboard, ListTodo, LogOut, MailPlus, Mails, MessageSquareDot, ReceiptText, ReceiptTextIcon, ScrollText, ServerCog, ShieldUser, SquareCheckBig, SquareKanban, SquareLibrary, ToggleRight, UserCog, UserPlus, Users, UserSearch } from "lucide-react";
import ModalContainerLogout from "../../Components/Others/ModalcontainerLogout";
import { ContractMenuStorage } from "../../Components/Utils/ContractLocal";

function Navbar() {
  const toast = useToast();
  const userDetails = DecryptData("sLiAtEdReSuEdArT") || "";
  const hasMutipleOffice = localStorage.getItem("hasmutiple")
    ? JSON.parse(localStorage.getItem("hasmutiple"))
    : false;
  const branchId = localStorage.getItem("branchId")
    ? JSON.parse(localStorage.getItem("branchId"))
    : 1;
  const { officeId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);
  const [msgCount, setMsgCount] = useState(0);
  const [message, setMessage] = useState([]);
  const { updateCurrency,updateCurrencySeparator } = useCurrency();

  const [open, setOpen] = useState(false);
  const [noti, setNoti] = useState([]);
  const [title, setTitle] = useState({
    Name: "",
    Country: "",
  });

  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);


function getData() {
  axiosInstance
    .get(`/menus/all-menus`)
    .then((res) => {
      const menus = res?.data?.data;
      setData(menus);
      setInitialData(JSON.parse(JSON.stringify(menus)));

        const formEnabledSettings = [];
      menus.forEach((menu) => {
        menu.formList?.forEach((form) => {
          formEnabledSettings.push({
            name: form.name.toLowerCase().replace(/\s/g, "_"),
            enabled: form.enabled,
          });
        });
      });
      ContractMenuStorage.set(formEnabledSettings);
    })
    .catch((err) => {
      console.log(err);
    });
}

  useEffect(() => {
    getData();
  }, []);

  function getCompanyName() {
    axiosInstance
      .get(`/company-info/1`)
      .then((res) => {
        res.data?.data &&
          setTitle({
            Name: res.data?.data?.companyName,
            Country: res.data.data?.compLogo?.file || "",
          });
        updateCurrency(res.data.data?.currency);
        updateCurrencySeparator(res.data.data?.currency_separator);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getNotifications(userId) {
    axiosInstance
      .get(`/notification/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setNoti(data?.notifications || []);
          data && setNotifCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getComments(userId) {
    axiosInstance
      .get(`/notification/comments/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setMessage(data?.notifications || []);
          data && setMsgCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getCompanyName();
    getNotifications(userDetails?.id);
    getComments(userDetails?.id);
  }, []);

  const { connectionOn, handleNotifications, handleActiveUser } = useSocket();

  useEffect(() => {
    if (connectionOn == true) {
      handleNotifications((notification) => {
        if (notification.type == 1) {
          setNotifCount((prev) => prev + 1);
          setNoti((prev) => [notification, ...prev]);
        } else if (notification.type == 2) {
          setMsgCount((prev) => prev + 1);
          setMessage((prev) => [notification, ...prev]);
        }
        toast.open(
          {
            message: "New Notification",
            description: notification?.msg || "",
            name: notification?.name || "",
            date: notification?.date || "",
            time: notification?.time || "",
            type: "notification",
          },
          5000,
          true
        );
      });
    }
  }, [handleNotifications, connectionOn]);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (connectionOn == true && GetRole()) {
      handleActiveUser((userList) => {
        setUserList(userList);
      });
    }
  }, [handleActiveUser, connectionOn]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const { pathname } = useLocation();
  
  const Space = ({ children }) => {
    return <div className="flex">{children}</div>;
  };

  const Badge = ({ count, children }) => {
    return (
      <div className="relative inline-block">
        {children}
        {count > 0 && (
          <span className="absolute top-0 p-1 right-0 bg-red-500 text-white w-4 h-4 flex items-center justify-center rounded-full text-[8px]">
            {count}
          </span>
        )}
      </div>
    );
  };

  const Dropdown = ({ overlay, children, trigger }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleTrigger = () => {
      if (trigger === "click") {
        toggleDropdown();
      }
      // You can add support for other trigger events here if needed
    };

    return (
      <div
        className="relative inline-block"
        onClick={handleTrigger}
        ref={dropdownRef}
      >
        <div>{children}</div>
        {isOpen && (
          <div className="absolute right-[100%] top-[70%] w-48 bg-white rounded-md shadow-lg z-[99]">
            {overlay}
          </div>
        )}
      </div>
    );
  };

  const getUnreadCount = () => {
    return noti.filter((noti) => !noti.is_read).length;
  };

  function Menu() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      switch (module) {
        case "survey":
          navigate(
            `/Contract-management/survey-report/view/${id}`
          );
          break;
        case "extinguisher":
          navigate(`/collectionAndreturn/fireExtinguisher/view/${id}`);
          break;
        case "suppresion":
          navigate(`/collectionAndreturn/fireSuppression/view/${id}`, {
            state: { active: 2 },
          });
          break;
        case "inspection":
          navigate(`/inspection/schedule/view/${id}`);
          break;
        case "my_task":
          navigate(`/tasks/my-tasks/view/${id}`);
          break;
           case "all_task":
          navigate(`/tasks/all-tasks/view/${id}`);
          break;
        case "testing_commision":
          navigate(`/testingAndcommisioning/schedules/view/${id}`);
          break;
        case "support_ticket":
          navigate(`/tickets/support-tickets/view/${id}`);
          break;
           case "client_ticket":
          navigate(`/tickets/client-tickets/view/${id}`);
          break;
        default:
          console.error("Invalid module");
      }
    };
    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete`)
        .then((res) => {
          setNoti([]);
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <div className="w-72 h-96 bg-white shadow-lg rounded-md overflow-hidden">
      <div className="w-full h-10 bg-red-200 flex justify-between items-center">
        <p className="font-bold ml-2">Notification</p>
        <div className="flex items-center gap-2">
          {notifCount > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-baseColor-primary text-white cursor-pointer"
              onClick={MarkAll}
            >
              Mark as Read
            </button>
          )}
          {noti.length > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-baseColor-primary text-white cursor-pointer"
              onClick={ClearAll}
            >
              Clear All
            </button>
          )}
        </div>
      </div>
      <div className="w-full h-[90%] overflow-y-scroll">
        {noti.map((notification, idx) => (
          <div
            key={idx}
            className={`w-full my-1 p-1  gap-1 flex justify-between items-center cursor-pointer border-b`}
            onClick={() => {
              handleRead(notification.notificationId);
              handleNavigate(notification.module, notification.id);
            }}
          >
            <div className="px-2 w-[15%] ">
              <div className="w-8 h-8 bg-baseColor-primary flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                {notification.sender_imageUrl ? (
                  // <img
                  //   src={notification.sender_imageUrl}
                  //   width="50px"
                  //   alt="Sender"
                  // />
                  <img
                                            src={
                                              notification.sender_imageUrl
                                                ? notification.sender_imageUrl
                                                : null
                                            }
                                            width="50px"
                                            alt={`${notification.sender_imageUrl}`}
                                          />
                ) : (
                  `${notification.name.charAt(0)}`
                )}
              </div>
            </div>
            <div
              className={`w-[85%] ${
                notification.is_read ? "font-normal" : "font-semibold"
              }`}
            >
                <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                       {notification?.msg}
                     </p>
                     <p className="text-[10px] text-slate-700">
                       By {notification?.name}{" "}
                       {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                       <span className="text-[8px] text-slate-700">
                         <NuDate
                           value={`${notification?.date} ${notification?.time}`}
                           format="hh:mm a"
                         />
                       </span>
                     </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    );
  }

  function Message() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      navigate(`/procurement/purchase-requests/view/${id}`);
    };

    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete/comments`)
        .then((res) => {
          setMessage([]);
          setMsgCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/comments/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <>
        <div className="w-72 h-96 z-[99]  bg-white shadow-lg rounded-md overflow-hidden">
          <div className=" w-full h-10 bg-red-200 flex justify-between items-center">
            <p className="font-bold ml-2">Comments</p>
            <div className=" flex items-center gap-2">
              {msgCount > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-baseColor-primary"
                  onClick={MarkAll}
                >
                  Marks as read
                </button>
              ) : null}
              {message.length > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-baseColor-primary"
                  onClick={ClearAll}
                >
                  Clear All
                </button>
              ) : null}
            </div>
          </div>
          <div className="w-full h-[90%] overflow-y-scroll">
            {message?.map((notification, idx) => {
              return (
                <>
                  <div
                    className={
                      // notification?.is_read ? "bg-white" : " bg-slate-100"
                    `w-full my-1 p-1 border-b gap-1 flex justify-between items-center cursor-pointer`}
                    onClick={() => {
                      notification?.is_read != true && handleRead(notification?.notificationId);
                      handleNavigate(notification.module, notification.id);

                    }}
                  >
               
                    <div className="px-2 w-[15%]">
                      {/* <NuAvatarGroup userdetails={[{name:`${notification?.sender_fName}`,imageUrl:`${notification?.sender_imageUrl}`}]} />    */}
                      <div className="w-8 h-8 bg-baseColor-primary  flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                        {notification.sender_imageUrl ? (
                          <img
                            src={
                              notification.sender_imageUrl
                                ? notification.sender_imageUrl
                                : null
                            }
                            width="50px"
                            alt={`${notification.sender_imageUrl}`}
                          />
                        ) : (
                          `${notification?.name?.charAt(0)}`
                        )}
                      </div>
                    </div>
                    <div
                      className={`w-[85%] ${
                        notification?.is_read
                          ? " font-normal "
                          : "font-medium  "
                      }`}
                    >
                      {/* <p className='font-semibold'>Admin <span className='font-normal'>to</span> Login Person</p> */}
                      <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                        {notification?.msg}
                      </p>
                      <p className="text-[10px] text-slate-700">
                        By {notification?.name}{" "}
                        {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                        <span className="text-[8px] text-slate-700">
                          <NuDate
                            value={`${notification?.date} ${notification?.time}`}
                            format="hh:mm a"
                          />
                        </span>
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </>
    );
  }

  const handleLogOut = async () => {
    setIsModalOpen(true);
  };

  function OnlineUsers({ list = [] }) {
    return (
      <>
        <div className="w-72 h-96 relative  bg-white shadow-lg rounded-md overflow-y-auto overflow-x-hidden px-2">
          <p className=" w-full sticky top-0 py-1 bg-white font-semibold text-xs 2xl:text-sm text-gray-900">
            Online User
          </p>
          {list &&
            list.map((user, index) => (
              <div
                className=" w-full flex justify-start items-center gap-x-3 my-1"
                key={index}
              >
                <div className=" w-[45px] h-[45px] rounded-full text-white  flex justify-center overflow-hidden items-center bg-baseColor-primary border border-white">
                  {user.image != "" && user.image != null ? (
                    <>
                      <img
                        src={user.image}
                        alt="#"
                        height={"45px"}
                        width="auto"
                      />
                    </>
                  ) : (
                    <>{getInitials(user?.name || "")}</>
                  )}
                </div>
                <p className=" text-gray-900 font-medium text-xs 2xl:text-sm">
                  {user?.name}
                </p>
              </div>
            ))}
        </div>
      </>
    );
  }

  const getInitials = (name) => {
    const names = name.split(" ");
    if (names.length > 1) {
      return names[0][0] + names[1][0];
    }
    return names[0][0];
  };

 const NavItems = [
     {
       icon: <LayoutDashboard size={16} />,
       title: "Dashboard",
       hasSubMenu: false,
       hasAccess: true,
       link: GetDashboardRole("")
         ? "/dashboard"
         : GetDashboardRole("sales")
         ? `/dashboard/sales`
         : GetDashboardRole("procurement")
         ? `/dashboard/procurement`
         : GetDashboardRole("store")  
         ? `/dashboard/stores`
         : `/dashboard`,
     },
 
     {
       link: GetAccess("clients_view")
         ? `/client-management/clients`
        
         : "#",
       icon: (
         <>
           <Users size={16} />
         </>
       ),
       title: "Clients",
       // access: GetAccess("client_management_module"),
       hasAccess: ["clients_view"],
       hasSubMenu: false,
       subMenu: [],
     },
      {
           link: GetAccess("quotation_view") ? `/quotation/quote`: "#",
           icon: (
             <>
               <ReceiptText size={16} />
             </>
           ),
           title: "Quotation",
           hasAccess: ["quotation_view"],
           // access: GetAccess("Invoice_module"),
           hasSubMenu: false,
           subMenu: [],
         },
      {
       link: GetAccess("survey_view")
         ? `/Contract-management/survey-report`
         : GetAccess("contracts_view")
         ? `/Contract-management/contracts`
         :GetAccess("commissioning_schedules_view")
         ? `/testingAndcommisioning/schedules`
         :GetAccess("fire_extinguisher_view")
         ? `/collectionAndreturn/fireExtinguisher`
         : GetAccess("fire_suppression_view")
         ? `/collectionAndreturn/fireSuppression`
         : "#",
       icon: (
         <>
           <ReceiptTextIcon size={16} />
         </>
       ),
       title: "Contracts",
       // access: GetAccess("client_management_module"),
       hasAccess: ["survey_view", "contracts_view","commissioning_schedules_view","fire_extinguisher_view","fire_suppression_view"],
       hasSubMenu: false,
       subMenu: [],
     },

  {
       link: GetAccess("team_view")
         ? `/teammember/team`
         : GetAccess("team_availability")
         ? `/teammember/availability`
         : "#",
       icon: (
         <>
           <UserSearch size={16} />
         </>
       ),
       title: "Team",
       hasAccess: ["team_view", "team_availability"],
       access: GetAccess("team_module"),
       hasSubMenu: false,
     },
     {
       link: GetAccess("inspection_calendar_view")
         ? `/inspection/schedule`
         : GetAccess("inspection_schedule_view")
         ? `/inspection/calender`
         : "#",
       icon: (
         <>
           <ClipboardCheck size={16} />
         </>
       ),
       title: "Inspection",
       hasAccess: ["inspection_calendar_view", "inspection_schedule_view"],
       access: GetAccess("inspection_module"),
       hasSubMenu: false,
     },
     // {
     //   link: GetAccess("commissioning_schedules_view")
     //     ? `/testingAndcommisioning/schedules`
     //     : "#",
     //   icon: (
     //     <>
     //       <BookOpenCheck size={16} />
     //     </>
     //   ),
     //   title: "Commissioning",
     //   hasAccess: ["commissioning_schedules_view"],
     //   access: GetAccess("GetAccess("commissioning_schedules_view")
     //     ? `/testingAndcommisioning/schedules`"),
     //   hasSubMenu: false,
     //   subMenu: [],
     // },
 
     // {
     //   icon: (
     //     <>
     //       <FireExtinguisher size={16} />
     //     </>
     //   ),
     //   link: GetAccess("fire_extinguisher_view")
     //     ? `/collectionAndreturn/fireExtinguisher`
     //     : GetAccess("fire_suppression_view")
     //     ? `/collectionAndreturn/fireSuppression`
     //     : "#",
     //   title: "Refilling",
     //   // access: GetAccess("refilling_module"),
     //   hasAccess: ["fire_extinguisher_view", "fire_suppression_view"],
     //   hasSubMenu: false,
     //   subMenu: [],
     // },
 
     {
       icon: <SquareKanban size={16} />,
       link: GetAccess("client_tickets_view")
         ? `/tickets/client-tickets`
         : GetAccess("support_tickets_view")
         ? `/tickets/support-tickets`
         : "#",
       title: "Tickets",
       hasAccess: ["client_tickets_view", "support_tickets_view"],
       hasSubMenu: false,
       subMenu: [],
     },
 
     {
       link: GetAccess("invoice_out_view") ? `/invoice/invoice-outgoing` : "#",
       icon: (
         <>
           <ReceiptText size={16} />
         </>
       ),
       title: "Invoice",
       hasAccess: ["invoice_out_view"],
       // access: GetAccess("Invoice_module"),
       hasSubMenu: false,
       subMenu: [],
     },
 
     {
       icon: <ListTodo size={16} />,
       link: GetAccess("mytasks_view")
         ? `/tasks/my-tasks`
         : GetAccess("tasks_view")
         ? `/tasks/all-tasks`
         : "#",
 
       title: "Tasks",
       hasAccess: ["mytasks_view", "tasks_view"],
       hasSubMenu: false,
       subMenu: [],
     },
 
     {
       icon: <SquareLibrary size={16} />,
       title: "Forms",
       link: GetAccess("forms_view") ? `/forms/surveyforms` :GetAccess("insforms_view")
         ? `/forms/insforms`
         : "#",
 
       hasAccess: ["forms_view","insforms_view"],
       hasSubMenu: false,
       subMenu: [],
     },
     {
       link: GetAccess(
         "report_module",
         "report_client_management",
         "report_client",
         "report_survey",
         "report_contract",
         "report_inspection",
         "report_inspection_scheule",
         "report_commisioning",
         "report_commisioning_schedule",
         "report_refilling",
         "report_refilling_ext",
         "report_refilling_sup",
         "report_ticket",
         "report_ticket_client",
         "report_ticket_support",
         "report_task",
         "report_task_task",
         "report_invoice_outgoing",
         "report_invoice_outgoing"
       )
         ? `/report`
         : "#",
       icon: (
         <>
           <ScrollText size={16} />
         </>
       ),
       title: "Report",
       hasAccess: [
         "report_module",
         "report_client_management",
         "report_client",
         "report_survey",
         "report_contract",
         "report_inspection",
         "report_inspection_scheule",
         "report_commisioning",
         "report_commisioning_schedule",
         "report_refilling",
         "report_refilling_ext",
         "report_refilling_sup",
         "report_ticket",
         "report_ticket_client",
         "report_ticket_support",
         "report_task",
         "report_task_task",
         "report_invoice_outgoing",
         "report_invoice_outgoing",
       ],
       // access: GetAccess("report_module"),
       hasSubMenu: false,
       subMenu: [],
     },
     {
       link: GetAccess("email_view") ? `/email/email-sent` : "#",
 
       icon: <Mails size={16} />,
       title: "E-mail",
       hasAccess: ["email_view"],
       hasSubMenu: false,
 
       subMenu: [],
     },
 
     {
       link: GetAccess("consultants_view")
         ? `/contacts/consultants`
         : GetAccess("contacts_view")
         ? `/contacts/main-contractors`
         : GetAccess("installers_view")
         ? `/contacts/installers`
         : GetAccess("suppliers_view")
         ? `/contacts/suppliers`
         : "#",
       icon: <Contact size={16} />,
 
       title: "Contacts",
       hasAccess: [
         "consultants_view",
         "contacts_view",
         "installers_view",
         "suppliers_view",
       ],
       hasSubMenu: false,
     },
   ];

  const SettingsNavItem = [
    {
      icon: <Building2 size={16} />,
      title: "Company Info",
      link:'/settings',
      hasAccess:"companyinfo_view"

    },
    {
      icon: <Users size={16} />,
      title: "Client Management",
      link:`/settings/client-management`,
      hasAccess:"clientmanagement_view"

    },
      {
          icon: <ClipboardCheck size={16} />,
          title: "Quotation",
          link:`/settings/quotation`,
          hasAccess:"quotation_view"
    
        },
    {
      icon: <UserSearch size={16} />,
      title: "Team",
      link:`/settings/team`,
      hasAccess:"team_view"

    },
    {
      icon: <ClipboardCheck size={16} />,
      title: "Inspection",
      link:`/settings/inspection`,
      hasAccess:"inspection_view"

    },
    {
      icon: <BookOpenCheck size={16} />,
      title: "Commisioning",
      link:`/settings/commisioning`,
      hasAccess:"commisioning_view"

    },
    {
      icon: <FireExtinguisher size={16} />,
      title: "Refilling",
      link:`/settings/refilling`,
      hasAccess:"refilling_view"

    },
    {
      icon: <SquareKanban size={16} />,
      title: "Tickets",
      link:`/settings/tickets`,
      hasAccess:"tickets_view"

    },
    {
      icon: <ReceiptText size={16} />,
      title: "Invoice",
      link:`/settings/invoice`,
      hasAccess:"invoice_view"

    },
    {
      icon: <ListTodo size={16} />,
      title: "Task",
      link:`/settings/task`,
      hasAccess:"task_view"

    },
    {
      icon: <Contact size={16} />,
      title: "Contacts",
      link:`/settings/contacts`,
      hasAccess:"contact_view"

    },
    {
      icon: <Hammer size={16} />,
      title: "Equipments",
      link:`/settings/equiments`,
      hasAccess:"equipment_view"

    },
    // {
    //   icon: <ShieldUser size={16} />,
    //   title: "Inspector",
    //   link:`/settings/inspector`,
    //   hasAccess:"inspector_view"

    // },
   
    {
      icon: <UserCog size={16} />,
      title: "Role",
      link:'/settings/role',
      hasAccess:"roles_view"
    },
    {
      icon: <UserPlus size={16} />,
      title: "User",
      link:'/settings/user',
      hasAccess:"user_view"
    },
    //  {
    //       icon: <ToggleRight size={16} />,
    //       title: "Additional Menus",
    //       link:'/settings/contract-renewal',
    //       hasAccess:"enable_disable_view"
    //     },
    {
      icon: <BellDot size={16} />,
      title: "Notifications",
      link:'/settings/notifications',
      hasAccess:"notification_view"
    },
   
    {
      icon: <FileSliders size={16} />,
      title: "Reference",
      link:'/settings/reffrence',
      hasAccess:"reference_view"
    },
   
    {
      icon: <SquareCheckBig size={16} />,
      title: "Approval Permission",
      link:'/settings/statuspermission',
      hasAccess:"approvalpermission_view"
    },
      ...( (GetUseRole('super admin')) ? [{
      icon: <ToggleRight size={16} />,
      link: GetAccess("Form_Survey_view")
        ? `/settings/formsApprove/survey`
        : `/settings/formsApprove/inspection`,
      title: "Forms Category",
      hasAccess: "Form_Survey_view", // or leave undefined if no further check needed
      hasSubMenu: false,
      subMenu: [],
    }] : []),
    
     ...(GetUseRole('super admin')  ? [{
        icon: <LayoutDashboard size={16} />,
        title: "DashBoard Menus",
        link: '/settings/dash'
      }] : []),
       ...(GetUseRole('super admin')  ? [{
        icon: <ToggleLeft size={16} />,
        title: "AI Features",
        link: '/settings/aiFeatures'
      }] : []),
    // {
    //   icon: <ToggleRight size={16} />,
    //   title: "Form Category",
    //   link:'/settings/surForm',
    //   hasAccess:"surForm_view"
    // },
    {
      icon: <ServerCog size={16} />,
      title: "Email Server",
      link:'/settings/emailserverdetails',
      hasAccess:"emailserver_view"
    },
    {
      icon: <MailPlus size={16} />,
      title: "Template",
      link:'/settings/emailtemplate',
      hasAccess:"emailtemplates_view"
    },
    {
      icon: <BadgeCheck size={16} />,
      title: "Approval Status",
      link:'/settings/newApproval',
      hasAccess:"approvalstatus_view"
    },
    
    
    {
      icon: <ToggleRight size={16} />,
      title: "Enable / Disable",
      link:'/settings/enableDisable',
      hasAccess:"enable_disable_view"
    },
    
  ];
// Inside your component
const [showSettings, setShowSettings] = useState(false);
const location = useLocation();

// Automatically detect if we're in settings based on the route
useEffect(() => {
  setShowSettings(location.pathname.startsWith('/settings'));
}, [location.pathname]);

  return (
    <>
      <style jsx>{`
        .circle-container .circle {
          position: relative;
          display: inline-block;
        }

        .circle-container .circle .circle-tooltip {
          visibility: hidden;
          max-width: 250px;
          height: 16px;
          background-color: #fff;
          color: #555;
          text-align: center;
          border-radius: 5px;
          padding: 5px;
          position: absolute;
          z-index: 20;
          top: 100%; /* Position the tooltip above the circle */
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          border: 1px solid #048178;
        }

        .circle-container .circle:hover .circle-tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}</style>
      <nav className=" w-full flex justify-between z-50">
        <div className=" w-4 lg:w-6/12 h-full p-3">
          <div className=" hidden h-full items-center lg:flex">
            {
              <div className=" flex justify-center items-center gap-2">
                {title.Country && (
                  <div className="max-w-[150px] h-10 overflow-hidden flex justify-center items-center">
                    <img
                      src={title.Country}
                      style={{ height: "40px", width: "auto" }}
                      alt="#fff"
                    />
                  </div>
                )}
                <span className=" text-base capitalize font-medium">
                  {title.Name || " "}
                </span>
              </div>
            }
          </div>
          <div className=" lg:hidden cursor-pointer" onClick={showDrawer}>
            <MenuOutlined />
          </div>
        </div>
        {GetRole() && (
          <>
            <div className=" w-[65%] h-[60px] mr-2 flex justify-end items-center">
              <div
                className="circle-container"
                style={{ display: "flex", alignItems: "center" }}
              >
                {userList && userList.length > 0 ? (
                  userList.slice(0, 10).map((name, index) => (
                    <React.Fragment key={index}>
                      {index == 9 ? (
                        <>
                          <div
                            className="circle text-xs"
                            style={{
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              backgroundColor: "#3369ff",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "normal",
                              marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                              position: "relative",
                              zIndex: 1 + index, // Stack circles on top of each other
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              border: "1px solid #fff",
                            }}
                          >
                            <div className="">
                              <Dropdown
                                overlay={<OnlineUsers list={userList} />}
                                trigger="click"
                              >
                                <div className=" w-full h-full text-xs whitespace-nowrap">
                                  10+
                                </div>
                              </Dropdown>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          className="circle text-xs"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            backgroundColor: "#3369ff",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "normal",
                            marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                            position: "relative",
                            zIndex: 1 + index, // Stack circles on top of each other
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            border: "1px solid #fff",
                          }}
                        >
                          {name.image != "" && name.image != null ? (
                            <div className=" w-[25px] h-[25px] rounded-full flex justify-center items-center overflow-hidden">
                              <img
                                src={name.image}
                                alt="#"
                                className=" w-auto h-[35px] object-cover"
                              />
                            </div>
                          ) : (
                            <>{getInitials(name?.name || "")}</>
                          )}
                          <div className="circle-tooltip ">
                            <div className=" -mt-[5px] text-xs whitespace-nowrap">
                              {name?.name || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <p> </p>
                )}
              </div>
            </div>
          </>
        )}
        <div className=" flex justify-center items-center">
          <div className="px-0.5 mr-2 bg-red-100 w-7 text-gray-700 h-7 rounded-lg flex justify-center items-center  cursor-pointer">
            <Link
              to={
                hasMutipleOffice == true
                  ? `/main-page/dashboard`
                  : GetDashboardRole("")
                  ? `/dashboard`
                  : GetDashboardRole("sales")
                  ? `/dashboard/sales`
                  : GetDashboardRole("procurement")
                  ? `/dashboard/procurement`
                  : GetDashboardRole("store")
                  ? `/dashboard/stores`
                  : `/dashboard`
              }
            >
              <LayoutDashboard size={16} />
            </Link>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={msgCount}>
                <Dropdown overlay={<Message />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer text-gray-700 bg-red-100 w-7  h-7 rounded-lg">
                  <MessageSquareDot size={16} />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={notifCount||0}>
                <Dropdown overlay={<Menu />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer bg-red-100 text-gray-700 w-7  h-7 rounded-lg">
                  <BellDot size={16} />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>

          <div class=" md:p-2 flex items-center">
            <div className="dropdown inline-block relative">
              <button className=" text-gray-700 outline-none border-none bg-transparent font-semibold md:px-4 flex items-center">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                </svg>
                <div className=" relative w-9 h-9 mx-2 rounded-full bg-white overflow-hidden">
                  <div className="absolute z-10 bg-transparent top-0 left-0 w-full h-9 border rounded-full border-solid border-gray-400"></div>
                  {/* <div className="absolute z-20 bottom-0 right-0 bg-transparent w-1/2 h-9 border-8 rounded-r-full border-solid border-white -[#F4F2F8]"></div> */}
                  <div className="absolute z-30 w-full [calc(36px-4px)] h-full text-gray-600 [calc(36px-4px)] flex justify-center  capitalize items-center bg-transparent">
                    {
                      userDetails.image?
                      <img src={userDetails.image} alt="#"/>
                      :<div>{userDetails?.name?.charAt(0)}</div>
                    }
                  </div>
                </div>
                <div className=" hidden md:flex flex-col leading-none">
                  <p className="text-xs 2xl:text-sm font-semibold text-gray-500">
                    {userDetails?.name || " "}
                    {/* {userDetails?.userLastName || " "} */}
                  </p>
                </div>
              </button>
              <ul className="dropdown-menu  leading-none z-50 absolute hidden shadow-sm border rounded-lg">
                <li className="list-none">
                  <Link
                    to={`/profile`}
                    className="rounded-t text-xs  bg-white font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                  >
                    Profile
                  </Link>
                </li>

                <li className="list-none cursor-pointer">
                  <div
                    className="rounded-b text-xs  bg-white font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                    onClick={handleLogOut}
                  >
                    Log Out
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ModalContainerLogout
          visiable={isModalOpen}
          title="Want to Logout?"
          content="Are you sure to logout from this app!"
          handleClick={() => logout()}
          closeModal={() => setIsModalOpen(false)}
        />
      </nav>

  



<Drawer title="" placement="left" onClose={onClose} open={open}>
  <div className="h-[calc(100vh-110px)] flex flex-col overflow-hidden">
    {/* Fixed height container with scroll */}
    <div className="flex-1 overflow-y-auto">
      {!showSettings ? (
        // Show regular nav items when not in settings view
        <>
          {NavItems.map((item, index) => {
            const { icon, title, hasAccess, link } = item;
            return (
              <div key={index} className="mb-1">
                {(hasAccess == true || GetMultipleAccess(hasAccess || [])) && (
                  <NavLink
                    to={link}
                    className={({ isActive }) =>
                      isActive
                        ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-red-300 block text-white`
                        : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-red-100`
                    }
                    onClick={onClose}
                  >
                    <div className="flex gap-2 items-center h-full">
                      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                        {icon}
                      </span>
                      <div className="text-xs font-medium">{title}</div>
                    </div>
                  </NavLink>
                )}
              </div>
            );
          })}

          {GetMultipleAccess([
             "settings_view",
          "companyinfo_view",
          "clientmanagement_view",
          "inspection_view",
          "commisioning_view",
          "refilling_view",
          "tickets_view",
          "invoice_view",
          "task_view",
          "contact_view",
          "equipment_view",
          "inspector_view",
          "roles_view",
          "user_view",
          "notification_view",
          "reference_view",
          "approvalpermission_view",
          "emailserver_view",
          "emailtemplates_view",
          "enable_disable_view",
          ]) && (
            <div className="mb-1">
              <NavLink
                to="/settings"
                className={({ isActive }) =>
                  isActive
                    ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-red-300 block text-white`
                    : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-red-100`
                }
              >
                <div className="flex gap-2 items-center h-full">
                  <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                    <Settings size={16} />
                  </span>
                  <div className="text-xs font-medium">Settings</div>
                </div>
              </NavLink>
            </div>
          )}

          <div className="mb-1">
            <Link
              to="#"
              className="w-full h-8 rounded-[6px] px-2 overflow-hidden border block hover:bg-red-100"
              onClick={() => {
                handleLogOut();
                onClose();
              }}
            >
              <div className="flex gap-2 items-center h-full">
                <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                  <LogOut size={16} />
                </span>
                <div className="text-xs font-medium">Logout</div>
              </div>
            </Link>
          </div>
        </>
      ) : (
        // Show settings nav items when in settings view
        <>
         <div className="mb-1">
  <NavLink
    to="/dashboard"  
    className="w-full h-8 rounded-[6px] px-2 overflow-hidden border block hover:bg-red-100"
  >
    <div className="flex gap-2 items-center h-full">
      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
        <ArrowLeft size={16} />
      </span>
      <div className="text-xs font-medium">Back to Menu</div>
    </div>
  </NavLink>
</div>

          {SettingsNavItem.map((item, index) => {
            const { icon, title, hasAccess, link } = item;
            return (
              <div key={index} className="mb-1">
                {GetAccess(hasAccess || "") && (
                  <NavLink
                    to={link}
                    className={({ isActive }) =>
                      isActive
                        ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-red-300 block text-white`
                        : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-red-100`
                    }
                    onClick={onClose}
                  >
                    <div className="flex gap-2 items-center h-full">
                      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                        {icon}
                      </span>
                      <div className="text-xs font-medium">{title}</div>
                    </div>
                  </NavLink>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  </div>
</Drawer>
    </>
  );
}

export default Navbar;
